import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  textColor: () => css`
    color: ${colors.transparent.gray60};
  `,
}
